<template>
  <!--  <GridsOutterGrid class="pointer-events-none left-0 w-screen">-->
  <GridsTwelveGrid class="col-start-2">
    <div class="leaf-path-container col-start-5 laptop:col-start-11 relative">
      <svg
        width="42"
        height="48"
        viewBox="0 0 42 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="z-100 absolute left-0 top-0"
      >
        <path ref="path" d="M39.5 1C28 24 22.5 31 1.5 46" stroke="#2E1818" stroke-width="4" />
      </svg>
    </div>
  </GridsTwelveGrid>
  <!--  </GridsOutterGrid>-->
  <img class="leaf opacity-0" :class="{ 'laptop:opacity-100': loaded }" ref="leaf" src="/images/leaf-2.png" />
</template>

<script setup lang="ts">
const loaded = ref(false);
import { gsap } from "gsap";
import { useWaitForPageTransitionEnd } from "~~/composables/waitPageTransition";

const { promise } = useWaitForPageTransitionEnd();

let tl;

const path = ref(null);
const leaf = ref(null);

onMounted(() => {
  initAnimation();
});

onBeforeUnmount(() => {
  if (tl) {
    tl.kill();
    tl = null;
  }

  loaded.value = false;
});

const { width, height } = useWindowSize();

watch(
  [width, height],
  () => {
    if (tl) {
      tl.kill();
      tl = null;

      initAnimation();
    }
  },
  { deep: true },
);

async function initAnimation() {
  await promise.value;

  if (path.value && leaf.value) {
    tl = gsap.timeline({
      scrollTrigger: {
        trigger: path.value,
        scrub: 4,
        // markers: true,
        start: "top 80%",
        end: "bottom 10%",
      },
    });
    tl.to(leaf.value, {
      // duration: 2,
      // repeat: 12,
      // repeatDelay: 0,
      // yoyo: true,
      ease: "none",
      immediateRender: true,
      motionPath: {
        path: path.value,
        align: path.value,
        autoRotate: 230,
        alignOrigin: [0.5, 0.5],
        // matrix: { a: 5, b: 0, c: 0, d: 5, e: 0, f: 0 },
        type: "cubic",
      },
    });

    loaded.value = true;
  }
}
</script>

<style scoped lang="scss">
.leaf {
  //width: 120px;
  //height: 60px;
  pointer-events: none;
  //background-color: #aa00ee;
  //color: black;
  //text-align: center;
  //line-height: 60px;
  position: absolute;
  top: 30%;
  left: 60%;
  //font-size: 32px;
}
path {
  fill: none;
  //stroke: #f00;
  stroke: none;
}
</style>
